import { AxiosError, isAxiosError } from 'axios'

import { useNotification } from '@gohighlevel/ghl-ui'
import { useI18n } from 'vue-i18n'

export const useNotify = () => {
  const notification = useNotification()
  const { t } = useI18n()

  const enableNotification = (type: 'success' | 'info' | 'warning' | 'error', title: string, message: string) => {
    notification[type]({
      title,
      description: message,
      duration: 10000,
    })
  }

  const handleError = (err: Error | AxiosError) => {
    if (isAxiosError(err)) {
      const axiosError = err as AxiosError
      if (axiosError.response?.status === 401 && axiosError.response?.data?.message === 'Invalid JWT') {
        return
      }
      if (axiosError.response?.data) {
        enableNotification('error', t('common.error'), axiosError.response.data?.message as string)
      }
    }
  }

  const handleErrorMessage = (err: string) => {
    enableNotification('error', t('common.error'), err)
  }
  const handleInfo = (title: string, message?: '') => {
    enableNotification('info', title, message)
  }

  const handleSuccess = (message: string) => {
    enableNotification('success', t('common.success'), message)
  }
  return {
    handleError,
    handleSuccess,
    handleErrorMessage,
    handleInfo,
  }
}
